import styles from './styles/ReviewReport.module.scss';
import { useRef, useState, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import MyIcon from '@/components/MyIcon';
import { Display } from '@/components/Display/Display';
import { Hide } from '@/components/Hide';
import SimulationImg from '../components/SimulationImg';
import ResultLoading from './components/Loading/ResultLoading';
import ErrorPage from './components/ErrorPage';
import useReviewReport from '@/pages/hooks/CaseSImulation/useReviewReport';
import useEvaluation, { SCENE_KEY } from '@/pages/hooks/CaseSImulation/useEvaluation';
import EvaluationModal from './components/Evaluation';
import titleImg from '@/assets/images/mobile/simulation/reportTitle.webp';
import doubleArrowImg from '@/assets/images/mobile/simulation/doubleArrow.webp';
import titleLeftImg from '@/assets/images/mobile/simulation/titleLeft.webp';
import titleRightImg from '@/assets/images/mobile/simulation/titleRight.webp';
import downloadImg from '@/assets/images/mobile/simulation/download.webp';
import toTopImg from '@/assets/images/mobile/simulation/toTop.webp';
import { cloneDeep } from 'lodash';
import ToastUtils from '@/utils/ToastUtils';
// 已评价胶囊图标 / 去评价星标（与 PC 共用素材）
const evaluatedIcon = require('@/assets/images/simulation/evaluationTool/emoji/emoji_6.webp');
const evaluateStarIcon = require('@/assets/images/simulation/evaluationTool/big_star_light.webp');
const ReviewReport = (props) => {
    const mainContentRef = useRef(null);
    const [showBackToTop, setShowBackToTop] = useState(false);
    const { pageLoading, loading, reGenerateReport } = useReviewReport({ ...props, side: 'mobile' });
    const { simulation } = props.store;
    let { agentId, caseId, sceneId } = props.params;
    // 评价功能状态与逻辑（PC/H5 公共 hook）
    const {
        evaluateOpen,
        evaluated,
        evaluateVisible,
        setEvaluateVisible,
        getEvaluateParams,
        initEvaluate,
        onEvaluateClick,
        onEvaluateSuccess
    } = useEvaluation({ agentId, caseId, sceneId });

    useEffect(() => {
        initEvaluate();
    }, []);

    let { reviewReport = {}, reportCards = [], setReportCards, pageProgress } = simulation;

    const downloadReport = () => {
        ToastUtils.showToast('请在PC端下载报告');
    };
    const returnTop = () => {
        mainContentRef.current?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const handleCollapse = (item) => {
        let data = cloneDeep(reportCards);
        data.forEach((ele) => {
            ele.expand = false;
        });
        setReportCards(data);
    };
    const handleExpand = (item) => {
        let data = cloneDeep(reportCards);
        data.forEach((ele) => {
            if (ele.scenario_id === item.scenario_id) {
                ele.expand = true;
            } else {
                ele.expand = false;
            }
        });
        setReportCards(data);
    };
    const handleScroll = (e) => {
        const scrollContainer = e.target;
        setShowBackToTop(scrollContainer.scrollTop > 0);
    };

    return (
        <div className={styles.container} data-loading={loading || pageLoading}>
            <Display show={pageLoading}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                    <ResultLoading />
                </div>
            </Display>
            <Display show={!pageLoading}>
                <>
                    <Display show={loading}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
                            <ResultLoading text="正在生成复盘报告，请稍后"></ResultLoading>
                        </div>
                    </Display>
                    <Display show={!loading}>
                        <Display show={pageProgress === null}>
                            <ErrorPage onClick={reGenerateReport} />
                        </Display>
                        <Display show={pageProgress !== null}>
                            <>
                                <div className={styles.actionWrap}>
                                    <Hide show={showBackToTop}>
                                        <div onClick={returnTop} className={styles.returnTop}>
                                            <img src={toTopImg} alt="回到顶部" />
                                        </div>
                                    </Hide>

                                    <div onClick={downloadReport} className={styles.download}>
                                        <img src={downloadImg} alt="下载报告" />
                                    </div>
                                </div>
                                {/* 标题部分 */}
                                <div className={styles.header}>
                                    <img src={titleImg} alt="【复盘报告】" />
                                </div>
                                <div className={styles.mainContent} onScroll={handleScroll} ref={mainContentRef}>
                                    {/* 完整事件回顾 */}
                                    <div className={styles.groupBox} style={{ paddingTop: 0 }}>
                                        <div className={styles.sectionTitle}>完整事件回顾</div>
                                        {reportCards.map((item, index) => {
                                            return (
                                                <div key={index} className={styles.eventBox}>
                                                    <div
                                                        data-expand={item?.expand}
                                                        onClick={() => handleExpand(item)}
                                                        className={styles.unExpandItem}
                                                    >
                                                        <div className={styles.unExpandLeft}>
                                                            <div className={styles.eventNum}>{index > 8 ? index + 1 : '0' + (index + 1)}</div>
                                                            <div className={styles.eventTitle}>{item.scenario_title}</div>
                                                        </div>
                                                        <div className={styles.unExpandRight}>
                                                            查看分析
                                                            <img src={doubleArrowImg} alt="查看分析" />
                                                        </div>
                                                    </div>

                                                    <div className={styles.expandItemWrap} data-expand={item?.expand}>
                                                        <div className={styles.eventItem}>
                                                            <div className={styles.top}>
                                                                <div className={styles.eventInfo}>
                                                                    <div className={styles.eventNum}>{index > 8 ? index + 1 : '0' + (index + 1)}</div>
                                                                    <div className={styles.eventTitle}>{item.scenario_title}</div>
                                                                </div>
                                                                <SimulationImg
                                                                    className={styles['event-img']}
                                                                    src={item?.scenario_image}
                                                                    alt={item.scenario_title}
                                                                />
                                                            </div>
                                                            <div className={styles.bottom}>
                                                                <div className={styles.eventDetail}>{item?.scenario_description}</div>
                                                            </div>
                                                        </div>
                                                        <div className={styles.myChoice}>
                                                            <div className={styles.choiceTitle}>
                                                                <div className={styles.choiceTitleText}>
                                                                    <img src={titleLeftImg} alt="我的选择" />
                                                                    我的<span style={{ color: '#3B70FF' }}>选择</span>
                                                                    <img src={titleRightImg} alt="我的选择" />
                                                                </div>
                                                            </div>
                                                            <div className={styles.choiceContent}>{item?.choice_path}</div>
                                                            <div className={styles.choiceTitle} data-effect={true}>
                                                                <div className={styles.choiceTitleText}>
                                                                    <img src={titleLeftImg} alt="产生影响" />
                                                                    产生<span style={{ color: '#13A8A8' }}>影响</span>
                                                                    <img src={titleRightImg} alt="产生影响" />
                                                                </div>
                                                            </div>
                                                            <div className={styles.choiceContent}>{item?.impact_analysis}</div>
                                                        </div>
                                                        <div className={styles.collapse} onClick={() => handleCollapse(item)}>
                                                            收起
                                                            <img src={doubleArrowImg} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* 核心问题诊断 */}
                                    <div className={styles.groupBox}>
                                        <div className={styles.sectionTitle}>核心问题诊断</div>
                                        <div className={styles.diagnosisSection}>
                                            <ul className={styles.diagnosisList}>
                                                {reviewReport &&
                                                    reviewReport?.diagnosis?.map((ele, index) => {
                                                        return (
                                                            <li className={styles.diagnosisItem} key={index}>
                                                                {ele}
                                                            </li>
                                                        );
                                                    })}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className={styles.groupBox}>
                                        {/* 优化方向建议 */}
                                        <div className={styles.sectionTitle}>优化方向建议</div>
                                        <div className={styles.suggestionSection}>
                                            <ul className={styles.suggestionList}>
                                                {reviewReport &&
                                                    reviewReport?.suggestions?.map((ele, index) => {
                                                        return (
                                                            <li className={styles.suggestionItem} key={index}>
                                                                {ele}
                                                            </li>
                                                        );
                                                    })}
                                            </ul>
                                        </div>
                                    </div>

                                    {/* 评价入口：开关开启才渲染；未评价显示去评价卡片，已评价显示静态胶囊 */}
                                    <Display show={evaluateOpen === 1}>
                                        <div className={styles.evaluateSection}>
                                            {evaluated ? (
                                                <div className={styles.evaluatedCapsule}>
                                                    <img className={styles.evaluatedIcon} src={evaluatedIcon} alt="" />
                                                    感谢您的评价!
                                                </div>
                                            ) : (
                                                <div className={styles.evaluateCard}>
                                                    <div className={styles.evaluateTitle}>本次情景模拟的场景贴近真实工作情境吗?</div>
                                                    <div className={styles.evaluateAction} onClick={onEvaluateClick}>
                                                        <img className={styles.evaluateStar} src={evaluateStarIcon} alt="" />
                                                        <span>去评价</span>
                                                        <MyIcon className={styles.icon} type="icon-right" />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Display>

                                    {/* 案例仿真评价弹窗（H5 底部面板）：题库 JSON 驱动 */}
                                    <EvaluationModal
                                        open={evaluateVisible}
                                        scene={SCENE_KEY.caseSimulation}
                                        params={getEvaluateParams()}
                                        onClose={() => setEvaluateVisible(false)}
                                        onSuccess={onEvaluateSuccess}
                                    />
                                </div>
                            </>
                        </Display>
                    </Display>
                </>
            </Display>
        </div>
    );
};
export default withRouter(inject('store')(observer(ReviewReport)));
